const device = document.body.getBoundingClientRect().width <= 1024 ? 'mobile' : 'pc'

export default {
  namespaced: true,
  state () {
    return {
      device
    }
  },
  mutations: {
    setDevice (state, payload) {
      state.device = payload
    }
  },
  actions: {
  },
  getters: {
    isMobile (state) {
      return state.device === 'mobile'
    }
  }
}
